document.addEventListener('DOMContentLoaded', function() {
    // Lazy load images in the brand section
    const brandSection = document.querySelector('#shopify-section-template--17166831747264__section_brands_riXypB > section');
    if (!brandSection) return;
    const brandImages = brandSection.querySelectorAll('div.m-brands__container.m-section__content img');
    
    brandImages.forEach(img => {
        const src = img.getAttribute('src');
        img.setAttribute('data-src', src);
        img.removeAttribute('src');
        img.setAttribute('loading', 'lazy');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    img.setAttribute('src', img.getAttribute('data-src'));
                    observer.unobserve(img);
                }
            });
        });

        observer.observe(img);
    });

    // Lazy load images in the slideshow section
    const slides = document.querySelectorAll(
        '#shopify-section-template--17166831747264__slideshow_kaF7ri > section > div > m-slideshow > div > div.swiper-wrapper > div:not(.swiper-slide-active)'
    );

    slides.forEach(slide => {
        const slideImages = slide.querySelectorAll('img');
        
        slideImages.forEach(img => {
            const src = img.getAttribute('src');
            img.setAttribute('data-src', src); // Set data-src
            img.removeAttribute('src'); // Remove src to delay loading
            img.setAttribute('loading', 'lazy'); // Ensure lazy loading

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        img.setAttribute('src', img.getAttribute('data-src')); // Load image
                        observer.unobserve(img); // Stop observing after load
                    }
                });
            });

            observer.observe(img); // Start observing the image
        });
    });

    // Additional lazy loading logic based on screen size
    if (window.innerWidth > 767) { // Desktop only
        const desktopImages = document.querySelectorAll(
            '#shopify-section-template--17166831747264__slideshow_kaF7ri > section > div > m-slideshow > div > div.swiper-wrapper > div.swiper-slide.m-color-background-4.m-gradient.swiper-slide-active > div > div.m-slide__media > a.m-slide__bg.md\\:m\\:hidden.m\\:block.m\\:w-full.m\\:h-full.m-slide__bg--adapt'
        );

        desktopImages.forEach(img => {
            const src = img.getAttribute('src');
            img.setAttribute('data-src', src);
            img.removeAttribute('src');
            img.setAttribute('loading', 'lazy');

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        img.setAttribute('src', img.getAttribute('data-src'));
                        observer.unobserve(img);
                    }
                });
            });

            observer.observe(img); // Start observing the image
        });
    } else { // Mobile only
        const mobileImages = document.querySelectorAll(
            '#shopify-section-template--17166831747264__slideshow_kaF7ri > section > div > m-slideshow > div > div.swiper-wrapper > div.swiper-slide.m-color-background-4.m-gradient.swiper-slide-active > div > div.m-slide__media > a.m-slide__bg.m\\:w-full.m\\:h-full.m-slide__bg--adapt.m\\:hidden.md\\:m\\:block'
        );

        mobileImages.forEach(img => {
            const src = img.getAttribute('src');
            img.setAttribute('data-src', src);
            img.removeAttribute('src');
            img.setAttribute('loading', 'lazy');

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        img.setAttribute('src', img.getAttribute('data-src'));
                        observer.unobserve(img);
                    }
                });
            });

            observer.observe(img); // Start observing the image
        });
    }
});
